export enum ModalId {
  CoApplicant,
  CreateSavedSearch,
  SearchBar,
  SoftPull
}

export enum NativeModalId {
  SoftPull = 'softPull'
}

export const ModalPriorities = {};
